/// <amd-module name="TFS/Admin/Common/RestClient/Organization" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\organization.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Organization from "../Contracts/Organization";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IOrganizationRestClient extends IVssRestClient {
    /**
     * Delete project collection avatar
     * 
     * @param collectionId - Id of the project collection
     */
    deleteCollectionAvatar(collectionId: string): Promise<void>;
    /**
     * Update project collection avatar
     * 
     * @param collectionId - Id of the project collection
     * @param imageData - 
     */
    updateCollectionAvatar(collectionId: string, imageData: number[]): Promise<void>;
    /**
     * @param collectionId - 
     * @param patchDocument - 
     */
    updateCollectionProperties(collectionId: string, patchDocument: VS_Services.JsonPatchDocument): Promise<boolean>;
    /**
     * @param collectionId - 
     * @param geographyName - 
     */
    backfillPreferredGeography(collectionId: string, geographyName: string): Promise<Organization.Collection>;
    /**
     * @param resource - 
     */
    createCollection(resource: Organization.Collection): Promise<Organization.Collection>;
    /**
     * @param collectionId - 
     * @param gracePeriodToRestoreInHours - 
     * @param violatedTerms - 
     */
    deleteCollection(collectionId: string, gracePeriodToRestoreInHours?: number, violatedTerms?: boolean): Promise<boolean>;
    /**
     * @param forceUpdateReason - 
     * @param collectionId - 
     * @param newOwner - 
     */
    forceUpdateCollectionOwner(forceUpdateReason: string, collectionId: string, newOwner: string): Promise<Organization.Collection>;
    /**
     * @param collectionId - 
     * @param propertyNames - 
     */
    getCollection(collectionId: string, propertyNames?: string[]): Promise<Organization.Collection>;
    /**
     * @param searchKind - 
     * @param searchValue - 
     * @param includeDeletedCollections - 
     */
    getCollections(searchKind?: Organization.CollectionSearchKind, searchValue?: string, includeDeletedCollections?: boolean): Promise<Organization.Collection[]>;
    /**
     * @param collectionId - 
     */
    isEligibleForTakeOver(collectionId: string): Promise<boolean>;
    /**
     * @param collectionId - 
     * @param collectionName - 
     */
    restoreCollection(collectionId: string, collectionName: string): Promise<boolean>;
    /**
     * @param patchDocument - 
     * @param collectionId - 
     */
    updateCollection(patchDocument: VS_Services.JsonPatchDocument, collectionId: string): Promise<Organization.Collection>;
    /**
     * Retrieves a set of all geographies available in Azure DevOps.
     * 
     */
    getGeographies(): Promise<Organization.Geography[]>;
    /**
     * @param organizationId - 
     * @param logo - 
     */
    updateOrganizationLogo(organizationId: string, logo: Organization.Logo): Promise<boolean>;
    /**
     * @param organizationId - 
     */
    exportOrganizationMigrationBlob(organizationId: string): Promise<Organization.OrganizationMigrationBlob>;
    /**
     * @param migrationBlob - 
     */
    importOrganizationMigrationBlob(migrationBlob: Organization.OrganizationMigrationBlob): Promise<void>;
    /**
     * @param organizationId - 
     * @param patchDocument - 
     */
    updateOrganizationProperties(organizationId: string, patchDocument: VS_Services.JsonPatchDocument): Promise<boolean>;
    /**
     * @param resource - 
     */
    createOrganization(resource: Organization.Organization): Promise<Organization.Organization>;
    /**
     * @param tenantId - 
     */
    getOldestOrganizationByTenant(tenantId: string): Promise<Organization.Organization>;
    /**
     * @param organizationId - 
     * @param propertyNames - 
     */
    getOrganization(organizationId: string, propertyNames?: string[]): Promise<Organization.Organization>;
    /**
     * @param searchKind - 
     * @param searchValue - 
     * @param isActivated - 
     */
    getOrganizations(searchKind: Organization.OrganizationSearchKind, searchValue: string, isActivated?: boolean): Promise<Organization.Organization[]>;
    /**
     * @param patchDocument - 
     * @param organizationId - 
     */
    updateOrganization(patchDocument: VS_Services.JsonPatchDocument, organizationId: string): Promise<Organization.Organization>;
    /**
     * @param includeRegionsWithNoAvailableHosts - 
     */
    getRegions(includeRegionsWithNoAvailableHosts?: boolean): Promise<Organization.Region[]>;
}

class OrganizationRestClient extends RestClientBase implements IOrganizationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Delete project collection avatar
     * 
     * @param collectionId - Id of the project collection
     */
    public async deleteCollectionAvatar(
        collectionId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.2-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Organization/Collections/{collectionId}/Avatar",
            routeValues: {
                collectionId: collectionId
            }
        });
    }

    /**
     * Update project collection avatar
     * 
     * @param collectionId - Id of the project collection
     * @param imageData - 
     */
    public async updateCollectionAvatar(
        collectionId: string,
        imageData: number[]
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.2-preview.1",
            method: "PUT",
            routeTemplate: "_apis/Organization/Collections/{collectionId}/Avatar",
            routeValues: {
                collectionId: collectionId
            },
            body: imageData
        });
    }

    /**
     * @param collectionId - 
     * @param patchDocument - 
     */
    public async updateCollectionProperties(
        collectionId: string,
        patchDocument: VS_Services.JsonPatchDocument
        ): Promise<boolean> {

        return this.beginRequest<boolean>({
            apiVersion: "7.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Organization/Collections/{collectionId}/Properties",
            routeValues: {
                collectionId: collectionId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     * @param collectionId - 
     * @param geographyName - 
     */
    public async backfillPreferredGeography(
        collectionId: string,
        geographyName: string
        ): Promise<Organization.Collection> {

        const queryValues: any = {
            geographyName: geographyName
        };

        return this.beginRequest<Organization.Collection>({
            apiVersion: "7.2-preview.1",
            method: "PUT",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param resource - 
     */
    public async createCollection(
        resource: Organization.Collection
        ): Promise<Organization.Collection> {

        return this.beginRequest<Organization.Collection>({
            apiVersion: "7.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            body: resource
        });
    }

    /**
     * @param collectionId - 
     * @param gracePeriodToRestoreInHours - 
     * @param violatedTerms - 
     */
    public async deleteCollection(
        collectionId: string,
        gracePeriodToRestoreInHours?: number,
        violatedTerms?: boolean
        ): Promise<boolean> {

        const queryValues: any = {
            gracePeriodToRestoreInHours: gracePeriodToRestoreInHours,
            violatedTerms: violatedTerms
        };

        return this.beginRequest<boolean>({
            apiVersion: "7.2-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param forceUpdateReason - 
     * @param collectionId - 
     * @param newOwner - 
     */
    public async forceUpdateCollectionOwner(
        forceUpdateReason: string,
        collectionId: string,
        newOwner: string
        ): Promise<Organization.Collection> {

        const queryValues: any = {
            newOwner: newOwner
        };

        return this.beginRequest<Organization.Collection>({
            apiVersion: "7.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues,
            body: forceUpdateReason
        });
    }

    /**
     * @param collectionId - 
     * @param propertyNames - 
     */
    public async getCollection(
        collectionId: string,
        propertyNames?: string[]
        ): Promise<Organization.Collection> {

        const queryValues: any = {
            propertyNames: propertyNames && propertyNames.join(",")
        };

        return this.beginRequest<Organization.Collection>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param searchKind - 
     * @param searchValue - 
     * @param includeDeletedCollections - 
     */
    public async getCollections(
        searchKind?: Organization.CollectionSearchKind,
        searchValue?: string,
        includeDeletedCollections?: boolean
        ): Promise<Organization.Collection[]> {

        const queryValues: any = {
            searchKind: searchKind,
            searchValue: searchValue,
            includeDeletedCollections: includeDeletedCollections
        };

        return this.beginRequest<Organization.Collection[]>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            queryParams: queryValues
        });
    }

    /**
     * @param collectionId - 
     */
    public async isEligibleForTakeOver(
        collectionId: string
        ): Promise<boolean> {

        return this.beginRequest<boolean>({
            apiVersion: "7.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            routeValues: {
                collectionId: collectionId
            }
        });
    }

    /**
     * @param collectionId - 
     * @param collectionName - 
     */
    public async restoreCollection(
        collectionId: string,
        collectionName: string
        ): Promise<boolean> {

        const queryValues: any = {
            collectionName: collectionName
        };

        return this.beginRequest<boolean>({
            apiVersion: "7.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param patchDocument - 
     * @param collectionId - 
     */
    public async updateCollection(
        patchDocument: VS_Services.JsonPatchDocument,
        collectionId: string
        ): Promise<Organization.Collection> {

        return this.beginRequest<Organization.Collection>({
            apiVersion: "7.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Organization/Collections/{collectionId}",
            routeValues: {
                collectionId: collectionId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     * Retrieves a set of all geographies available in Azure DevOps.
     * 
     */
    public async getGeographies(
        ): Promise<Organization.Geography[]> {

        return this.beginRequest<Organization.Geography[]>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/Geographies"
        });
    }

    /**
     * @param organizationId - 
     * @param logo - 
     */
    public async updateOrganizationLogo(
        organizationId: string,
        logo: Organization.Logo
        ): Promise<boolean> {

        return this.beginRequest<boolean>({
            apiVersion: "7.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Organization/Organizations/{organizationId}/Logo",
            routeValues: {
                organizationId: organizationId
            },
            body: logo
        });
    }

    /**
     * @param organizationId - 
     */
    public async exportOrganizationMigrationBlob(
        organizationId: string
        ): Promise<Organization.OrganizationMigrationBlob> {

        return this.beginRequest<Organization.OrganizationMigrationBlob>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/OrganizationMigrationBlobs/{organizationId}",
            routeValues: {
                organizationId: organizationId
            }
        });
    }

    /**
     * @param migrationBlob - 
     */
    public async importOrganizationMigrationBlob(
        migrationBlob: Organization.OrganizationMigrationBlob
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Organization/OrganizationMigrationBlobs/{organizationId}",
            body: migrationBlob
        });
    }

    /**
     * @param organizationId - 
     * @param patchDocument - 
     */
    public async updateOrganizationProperties(
        organizationId: string,
        patchDocument: VS_Services.JsonPatchDocument
        ): Promise<boolean> {

        return this.beginRequest<boolean>({
            apiVersion: "7.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Organization/Organizations/{organizationId}/Properties",
            routeValues: {
                organizationId: organizationId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     * @param resource - 
     */
    public async createOrganization(
        resource: Organization.Organization
        ): Promise<Organization.Organization> {

        return this.beginRequest<Organization.Organization>({
            apiVersion: "7.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Organization/Organizations/{organizationId}",
            body: resource
        });
    }

    /**
     * @param tenantId - 
     */
    public async getOldestOrganizationByTenant(
        tenantId: string
        ): Promise<Organization.Organization> {

        const queryValues: any = {
            tenantId: tenantId
        };

        return this.beginRequest<Organization.Organization>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/Organizations/{organizationId}",
            queryParams: queryValues
        });
    }

    /**
     * @param organizationId - 
     * @param propertyNames - 
     */
    public async getOrganization(
        organizationId: string,
        propertyNames?: string[]
        ): Promise<Organization.Organization> {

        const queryValues: any = {
            propertyNames: propertyNames && propertyNames.join(",")
        };

        return this.beginRequest<Organization.Organization>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/Organizations/{organizationId}",
            routeValues: {
                organizationId: organizationId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param searchKind - 
     * @param searchValue - 
     * @param isActivated - 
     */
    public async getOrganizations(
        searchKind: Organization.OrganizationSearchKind,
        searchValue: string,
        isActivated?: boolean
        ): Promise<Organization.Organization[]> {

        const queryValues: any = {
            searchKind: searchKind,
            searchValue: searchValue,
            isActivated: isActivated
        };

        return this.beginRequest<Organization.Organization[]>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/Organizations/{organizationId}",
            queryParams: queryValues
        });
    }

    /**
     * @param patchDocument - 
     * @param organizationId - 
     */
    public async updateOrganization(
        patchDocument: VS_Services.JsonPatchDocument,
        organizationId: string
        ): Promise<Organization.Organization> {

        return this.beginRequest<Organization.Organization>({
            apiVersion: "7.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Organization/Organizations/{organizationId}",
            routeValues: {
                organizationId: organizationId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     * @param includeRegionsWithNoAvailableHosts - 
     */
    public async getRegions(
        includeRegionsWithNoAvailableHosts?: boolean
        ): Promise<Organization.Region[]> {

        const queryValues: any = {
            includeRegionsWithNoAvailableHosts: includeRegionsWithNoAvailableHosts
        };

        return this.beginRequest<Organization.Region[]>({
            apiVersion: "7.2-preview.1",
            routeTemplate: "_apis/Organization/Regions",
            queryParams: queryValues
        });
    }

}

export const OrganizationClientName = "Organization-AdminArea.IOrganizationRestClient";

export function getOrganizationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IOrganizationRestClient {
    return pageContext.getRestClient<IOrganizationRestClient>(OrganizationClientName, options);
}

RestClients.add(OrganizationClientName, { 
    factory: OrganizationRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
